module.exports = __webpack_public_path__ + "media/images/backgrounds/add_new-48d4315b706f162c6bdbdf54c7f1e060.png";